"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const filters_1 = require("../filters");
const types_1 = require("./types");
const filterSections = {
    DateFilterIndex: {
        type: 'custom_date_range',
        key: types_1.DateFilterIndex,
        order: -3,
        header: 'Show Last',
        value: 'status',
        selectionType: filters_1.SelectionType.SINGLE,
        filters: [
            {
                order: 0,
                isSelected: false,
                name: '1 month',
                customDateFilterType: '1-month',
                customDateRangeStart: (0, moment_timezone_1.default)().subtract(1, 'months'),
                customDateRangeEnd: (0, moment_timezone_1.default)()
            },
            {
                order: 1,
                isSelected: false,
                name: '3 months',
                customDateFilterType: '3-months',
                customDateRangeStart: (0, moment_timezone_1.default)().subtract(3, 'months'),
                customDateRangeEnd: (0, moment_timezone_1.default)()
            },
            {
                order: 2,
                isSelected: false,
                name: '6 months',
                customDateFilterType: '6-months',
                customDateRangeStart: (0, moment_timezone_1.default)().subtract(6, 'months'),
                customDateRangeEnd: (0, moment_timezone_1.default)()
            },
            {
                order: 3,
                isSelected: false,
                name: '1 year',
                customDateFilterType: '1-year',
                customDateRangeStart: (0, moment_timezone_1.default)().subtract(1, 'year'),
                customDateRangeEnd: (0, moment_timezone_1.default)()
            },
            {
                order: 4,
                isSelected: false,
                name: 'Custom Date Range',
                customDateFilterType: 'custom',
                customDateRangeStart: null,
                customDateRangeEnd: null
            }
        ]
    }
};
exports.default = filterSections;
//# sourceMappingURL=filters.js.map